import { productCardFields } from '../../config/endpoint-fields/product-card.fields';

export const productSearchFields = [
  `products(${productCardFields.join(',')},indexedBundles(FULL),orderInCategories,images(FULL))`,
  'breadcrumbs(FULL)',
  'facets(category,multiSelect,name,priority,values,visible,facetNavigationType,storeFrontDisplay)',
  'pagination(currentPage,totalPages)',
  'sorts',
  'currentQuery(query(value))'
];
